import styled from 'styled-components';
import sctheme from 'app/styles/sctheme';

const ProgressContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
  height: ${props => props.height};
  background-color: ${sctheme.grays.$200};
  border-radius: 8px;
`;

const Bar = styled.div`
  width: ${props => props.progress}%;
  background-color: ${sctheme.blues.primary};
  border-radius: 8px;
  transition: width 0.3s ease;
`;

const ProgressBar = ({ progress, height }) => {
  return (
    <ProgressContainer className="table-progress-bar" height={height ? height : '20px'}>
      <Bar progress={progress} />
    </ProgressContainer>
  );
};

export default ProgressBar;
